// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2NXHC","content":"ManualTimeModal_content__9UTwi"};